// @flow
import { CLEAR_DOCUMENT, DECREASE_ZOOM, INCREASE_ZOOM, SET_DOCUMENT, } from '../actions/documentViewer';

import type { Action } from './types';

const initialState = {
    selectedDocument: null,
    zoom: 0.55
};

//Reducer that manages a playlist
export default function playlist( state = initialState, action: Action ) {
    switch ( action.type ) {

        case SET_DOCUMENT:
            const { doc } = action;
            return { ...state, selectedDocument: doc };
        case CLEAR_DOCUMENT:
            return initialState;
        case DECREASE_ZOOM:
            if ( state.zoom <= 0.10 ) {
                return state;
            }
            return { ...state, zoom: state.zoom - 0.05 };
        case INCREASE_ZOOM:
            if ( state.zoom >= 1 ) {
                return state;
            }
            return { ...state, zoom: state.zoom + 0.05 };
        default:
            return state;
    }
}